import { createSlice } from '@reduxjs/toolkit';

const signUpErrorMessageSlice = createSlice({
    name: 'signUpErrorMessage',
    initialState: null,
    reducers: {
        setSignUpErrorMessage: (state, action) => action.payload,
    },
});

export const { setSignUpErrorMessage } = signUpErrorMessageSlice.actions;

export default signUpErrorMessageSlice.reducer;
